export const CREATE_LIVESTREAM = gql`
  mutation CreateLivestream($input: CreateLivestreamInput!) {
    createLivestream(input: $input) {
      description
      embedCode
      id
      logo
      name
      pbsStationManagerLivestreamFeedCid
      shortDescription
      slug
      sourceUrl
      vimeoLiveEventId
    }
  }
`

export const DELETE_LIVESTREAM = gql`
  mutation DeleteLivestream($id: String!) {
    deleteLivestream(id: $id) {
      description
      embedCode
      id
      logo
      name
      pbsStationManagerLivestreamFeedCid
      shortDescription
      slug
      sourceUrl
      vimeoLiveEventId
    }
  }
`

export const GET_STATION = gql`
  query GetStation($id: String!) {
    station(id: $id) {
      about
      addressCity
      addressState
      addressStreet
      addressZip
      backgroundImagePreview: image(profile: "station-background") {
        image(transforms: { fit: CROP, height: 675, width: 1200 })
      }
      callSign
      colorBackground
      colorLogoPreview: image(profile: "station-color-logo") {
        image(transforms: { height: 100 })
      }
      colorPrimary
      colorSecondary
      email
      faviconPreview: image(profile: "station-favicon") {
        image(transforms: { height: 192 })
      }
      fax
      id
      images
      name
      passportLogoPreview: image(profile: "station-passport-logo") {
        image(transforms: { height: 100 })
      }
      phone
      primaryLogoPreview: image(profile: "station-logo-primary") {
        image(transforms: { height: 100 })
      }
      secondaryLogoPreview: image(profile: "station-logo-secondary") {
        image(transforms: { height: 100 })
      }
      urls
      users {
        name
        id
        roles
        email
        stationId
        active
      }
      webPortalLinks
      whiteLogoPreview: image(profile: "station-white-logo") {
        image(transforms: { backgroundColor: "#000000", height: 100 })
      }
    }
  }
`

export const GET_STATION_LIVESTREAMS = gql`
  query GetStationLivestreams($stationId: UUID!) {
    stationLivestreams(stationId: $stationId) {
      description
      embedCode
      id
      logo(transforms: { width: 150 })
      name
      pbsStationManagerLivestreamFeedCid
      shortDescription
      slug
      sourceUrl
      streamScheduleId
      vimeoLiveEventId
      weight
    }
  }
`

export const GET_STREAM_SCHEDULES = gql`
  query GetStreamSchedulesForSelection($stationId: UUID!) {
    streamSchedules(stationId: $stationId) {
      id
      name
      streamMediaType
    }
  }
`

export const UPDATE_LIVESTREAM = gql`
  mutation UpdateLivestream($id: String!, $input: UpdateLivestreamInput!) {
    updateLivestream(id: $id, input: $input) {
      id
      name
    }
  }
`

export const UPDATE_STATION = gql`
  mutation UpdateStation($id: String!, $input: UpdateStationInput!) {
    updateStation(id: $id, input: $input) {
      id
      about
      addressCity
      addressState
      addressStreet
      addressZip
      addressCountry
      email
      phone
      fax
      colorPrimary
      colorSecondary
      colorBackground
      images
      users {
        name
        id
        roles
        email
        stationId
        active
      }
      urls
      webPortalLinks
    }
  }
`

export const GET_PBS_LIVESTREAM_FEEDS = gql`
  query GetPbsLivestreamFeeds($stationId: UUID!) {
    pbsLivestreamFeeds(stationId: $stationId) {
      cid
      profile
    }
  }
`
